class ProductDescription extends HTMLElement {
  #host = null;
  #body = null;
  #variantsDescription = null;

  connectedCallback() {
    if (this.dataset.source !== 'variant') return;

    this.#host = this.closest('main-product');
    this.#body = this.querySelector('[data-description-body]');
    this.#variantsDescription = this.#parseDescriptionData();

    if (!this.#variantsDescription) return;

    this.#host?.addEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#host?.removeEventListener('pdp:variant-update', this.#onVariantUpdate);
  }

  #parseDescriptionData() {
    const node = this.querySelector('[data-variants-description]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      console.error('product-description: variants description JSON parse failed', err);
      return null;
    }
  }

  #onVariantUpdate = (event) => {
    const variant = event.detail?.variant;
    if (!variant || !this.#body) return;

    const desc = this.#variantsDescription[String(variant.id)] || this.#variantsDescription[variant.id];
    if (typeof desc !== 'string') return;

    this.#body.innerHTML = desc;
  };
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription);
}
